import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
  Container,
} from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import CakeSearchBar from "./CakeSearchBar";
import SelectedFilters from "./SelectedFilters";
import FilterSidebar from "./FilterSidebar";
import CakeCard from "./CakeCard";
import PaginationControls from "./PaginationControls";

const SpecialtyCakesDesktopView = ({
  cakes,
  loading,
  filters,
  setFilters,
  clearFilters,
  removeFilter,
  sortOption,
  setSortOption,
  clearSort,
  searchQuery,
  setSearchQuery,
  fetchCakes,
  currentPage,
  getEventTypeLabel,
  handlePageChange,
  attributeOptions,
  gridRef,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openSortMenu = Boolean(anchorEl);

  const handleSortClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSortClose = () => {
    setAnchorEl(null);
  };

  const handleSortOption = (option) => {
    setSortOption(option);
    fetchCakes();
    setAnchorEl(null);
  };

  return (
    <>
      <Container maxWidth="xl" disableGutters>
        <Box sx={{ px: 2, mt: 4 }}>
          {/* Search Bar */}
          <CakeSearchBar
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onSearch={(newQuery) => {
              setSearchQuery(newQuery);
              fetchCakes(newQuery);
            }}
          />

          {/* Top Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 4,
              py: 1,
              borderBottom: "1px solid #eee",
            }}>
            <Typography variant="subtitle1" fontWeight={600}>
              Found {cakes.length} results for{" "}
              <strong>
                {filters.recipient !== "All"
                  ? filters.recipient
                  : filters.eventType !== "All"
                  ? getEventTypeLabel(filters.eventType)
                  : "Specialty Cakes"}
              </strong>
            </Typography>

            {/* Sort Button */}
            <Button
              onClick={handleSortClick}
              startIcon={<SortIcon />}
              sx={{
                textTransform: "none",
                color: "text.secondary",
                fontWeight: 500,
                fontSize: 14,
              }}>
              Sort
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={openSortMenu}
              onClose={handleSortClose}>
              <MenuItem onClick={() => handleSortOption("popularity")}>
                Most Popular
              </MenuItem>
              <MenuItem onClick={() => handleSortOption("price-asc")}>
                Price: Low to High
              </MenuItem>
              <MenuItem onClick={() => handleSortOption("price-desc")}>
                Price: High to Low
              </MenuItem>
            </Menu>
          </Box>

          {/* Selected Filters */}
          <SelectedFilters
            filters={filters}
            sortOption={sortOption}
            removeFilter={removeFilter}
            clearSort={clearSort}
            clearFilters={clearFilters}
            getEventTypeLabel={getEventTypeLabel}
            decorOptions={attributeOptions.decor}
          />

          {/* Layout with Sidebar and Cake Listings */}
          <Box sx={{ display: "flex", mt: 3, gap: 2 }}>
            <Box
              sx={{
                width: "100%",
                maxWidth: 450,
                position: "sticky",
                top: 0,
                alignSelf: "flex-start",
              }}>
              <FilterSidebar
                filters={filters}
                setFilters={setFilters}
                clearFilters={clearFilters}
              />
            </Box>

            <Box
              sx={{
                flex: 1,
                transition: "opacity 0.5s ease, transform 0.5s ease",
                opacity: loading ? 0 : 1,
                transform: loading ? "translateY(10px)" : "translateY(0px)",
              }}
              ref={gridRef}>
              <Grid container spacing={3}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      minHeight: "300px",
                    }}>
                    <CircularProgress color="primary" size={50} />
                    <Typography variant="h6" sx={{ mt: 2, color: "#515151" }}>
                      Loading...
                    </Typography>
                  </Box>
                ) : cakes.length === 0 ? (
                  <Box
                    sx={{
                      textAlign: "center",
                      width: "100%",
                      py: 10,
                    }}>
                    <Typography variant="h5" fontWeight={600}>
                      No cakes found.
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, opacity: 0.7 }}>
                      Try adjusting your filters or clearing search.
                    </Typography>
                  </Box>
                ) : (
                  cakes.map((cake) => (
                    <Grid item xs={12} sm={6} md={4} key={cake._id}>
                      <CakeCard cake={cake} attributes={attributeOptions} />
                    </Grid>
                  ))
                )}
              </Grid>
            </Box>
          </Box>

          {/* <PaginationControls
            currentPage={currentPage}
            setCurrentPage={handlePageChange}
          /> */}
        </Box>
      </Container>
    </>
  );
};

export default SpecialtyCakesDesktopView;
